// PWA glue for OpenCSV — service worker registration + File Handlers API
// "Launch Queue" consumption.
//
// What "Launch Queue" gives us:
//   When a user right-clicks a .csv on Windows/Mac and picks "Open with →
//   OpenCSV" (because they installed us as a PWA), the browser launches our
//   PWA and pushes one or more FileSystemHandle objects onto
//   `window.launchQueue`. We must subscribe a consumer ASAP after startup,
//   read the file(s) as text, and dispatch the same internal
//   `opencsv:incoming-file` event that the Android FileIntentBridge uses.
//   The CsvEditor already listens for that event — no editor changes needed.

const INCOMING_EVENT = "opencsv:incoming-file";

export function registerServiceWorker() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    // Don't register on localhost during dev (avoids stale-cache pain).
    const isDev =
        process.env.NODE_ENV !== "production" ||
        /^localhost$|^127\./.test(window.location.hostname);
    if (isDev) return;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js", { scope: "/" })
            .catch(() => {/* swallow — SW is optional */ });
    });
}

export function registerLaunchQueueConsumer() {
    if (typeof window === "undefined") return;
    if (!("launchQueue" in window) || typeof window.launchQueue.setConsumer !== "function") return;

    window.launchQueue.setConsumer(async (launchParams) => {
        if (!launchParams || !launchParams.files || launchParams.files.length === 0) return;
        // Multiple files: open the first, ignore the rest for now. Users will
        // open them one at a time via Open With.
        const handle = launchParams.files[0];
        try {
            const file = await handle.getFile();
            const text = await file.text();
            const name = file.name || "incoming.csv";
            window.dispatchEvent(
                new CustomEvent(INCOMING_EVENT, { detail: { name, content: text } })
            );
        } catch {
            // Permission revoked / file gone — silently ignore.
        }
    });
}
